import React, { useState } from "react";
import { deleteWidget, getWidgets } from "../../../revampCRUD/widget.crud";
import customToast from "../../../components/common/basic/Toast";
import TippyIcon from "../../../revampComponents/Atom/TippyIcon";
import DataTableCustom from "../../../revampComponents/Atom/DataTable";
import { getISTDateNTime } from "../../../Utils/helpers";
import { cutString } from "../../../services/util";
import {
  DeleteQuickButton,
  EditQuickButton,
} from "../../../revampComponents/Atom/Buttons";
import { useHistory, useParams } from "react-router-dom";
import { CustomModal } from "../../../revampComponents/Atom/Modals";
import ButtonTippyCopy from "../../../revampComponents/Atom/ButtonTippyCopy";

const WidgetList = ({ props, widgetList, setWidgetList }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false)
  const [openGetURLModal, setOpenGetURLModal] = useState(false);
  const [modalWidgetUrl, setModalWidgetUrl] = useState("");
  const [isDeletingWidget, setIsDeletingWidget] = useState(false);
  const openUrlModal = (url) => {
    setModalWidgetUrl(url);
    setOpenGetURLModal(true);
  };


  const onClickHandler = (widgetId = null) => {
    history.push({
      pathname: widgetId
        ? `/e/${props?.eventInfo?.event_id}/developers/embed/edit/${widgetId}`
        : `/e/${props?.eventInfo?.event_id}/developers/embed/create`,
    });
  };
  const fetchWidgets = async () => {
    try {
      const res = await getWidgets();
      setWidgetList(res?.data || []);
    } catch (err) {
      customToast.error(err?.response?.data?.error || 'Something went wrong');
      setWidgetList([]);
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteWidget = async (widgetId) => {
   	if (isDeletingWidget) return;
    setIsDeletingWidget(true)
    try {
      const res = await deleteWidget(widgetId);
      await fetchWidgets();
      customToast.success("Widget Deleted Successfully");
      setIsDeletingWidget(false)
    } catch (err) {
      customToast.error(err?.response?.data?.error || 'Something went wrong');
      setIsDeletingWidget(false)

    }
  };

  const copyToClipboard = (widgetUrl) => {
    if (navigator?.clipboard) {
      navigator?.clipboard?.writeText(widgetUrl)?.then(() => {
        customToast.success("The URL has been copied");
      });
    }
  };
  const columns = [
    {
      name: "Widget Name",
      selector: "widget_name",
      sortable: false,
      ignoreRowClick: false,
      minWidth: "25%",
      maxWidth: "25%",
      sortField: "title",
      cell: (selector) => (
        <span data-tag="allowRowEvents">
          {selector?.widget_name ? cutString(selector?.widget_name, 30) : ""}
        </span>
      ),
    },
    {
      name: "Created On",
      ignoreRowClick: false,
      minWidth: "25%",
      maxWidth: "25%",
      selector: "created_at",
      cell: (selector) => (
        <TippyIcon
          content={
            <span data-tag="allowRowEvents" style={{ fontSize: "12px" }}>
              {getISTDateNTime(
                selector?.created_at,
                props?.eventInfo?.time_zone,
                "needed",
              )}
            </span>
          }
        >
          <span data-tag="allowRowEvents">
            {cutString(
              getISTDateNTime(
                selector?.created_at,
                props?.eventInfo?.time_zone,
                "needed",
              ),
              30,
            )}
          </span>
        </TippyIcon>
      ),
      sortable: false,
      sortField: "registered_at",
    },
    {
      name: "Button & Widget Script",
      selector: "button_id",
      minWidth: "25%",
      maxWidth: "25%",
      cell: (selector) => (
        <button
          onClick={() => openUrlModal(selector?.widget_url)}
          className="k-btn cancel-btn mr-0 mr-sm-0 mt-1  position-relative"
        >
          Get Widget Code
        </button>
      ),
      sortable: false,
    },

    {
      name: "Quick Actions",
      sortable: false,
      center: true,

      minWidth: "25%",
      maxWidth: "25%",
      cell: (selector) => (
        <div>
          <EditQuickButton
            className="mr-3"
            onClick={() => onClickHandler(selector?.widget_id)}
          />
          <DeleteQuickButton
            onClick={() => {
              handleDeleteWidget(selector?.widget_id);
            }}

          />
        </div>
      ),
      ignoreRowClick: true,
    },
  ];
  const conditionalRowStyles = [
    {
      when: (row) => row != null,
      style: {
        "&:hover": {
          cursor: "default",
        },
      },
    },
  ];
  return (
    <>
      <div className="m-1 p-2">
        {widgetList?.length !== 0 && (
          <div className="d-flex flex-column">
            <div className="d-flex justify-content-between align-items-center w-100 mb-3">
              <div>
                <p class="widget-type-txt ">Widgets</p>
                <p class="widget-type-desc">
                  Customize and embed your event ticketing widget to blend
                  perfectly with your website.
                </p>
              </div>
              <button
                type="button"
                class="k-btn save-btn position-relative"
                onClick={() => onClickHandler()}
              >
                Create Widget
              </button>
            </div>
            <CustomModal
              openModal={openGetURLModal}
              setOpenModal={setOpenGetURLModal}
              onRequestClose={() => setOpenGetURLModal(false)}
              contentLabel="Example Modal"
              content={
                <>
                  <div className="">
                    <p className="formTitle fw-bold mb-4 text-left">
                      Widget Code
                    </p>
                    <div className="code-div">
                      <p className="code-div-para">   {`<iframe src="${modalWidgetUrl}" id="konfhub-widget" title="Register for ${props?.eventInfo?.name}" width="100%" height="500"></iframe>`}</p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end mt-4">
                    <TippyIcon content="Copy code">
                      <ButtonTippyCopy
                        content={
                          `<iframe src="${modalWidgetUrl}" id="konfhub-widget" title="Register for ${props?.eventInfo?.name}" width="100%" height="500"></iframe>`
                        }
                        buttonText={"Copy"}
                      />
                    </TippyIcon>

                  </div>
                </>
              }
            />
            <DataTableCustom
              rowData={widgetList}
              columns={columns}
              handleRowChange={() => {}}
              selectableRows={false}
              search={"NotNeeded"}
              pagination={false}
              // conditionalRowStyles={conditionalRowStyles}
            />
          </div>
            
        )}
      </div>
      <style jsx global>{`
        .overflow-visible {
          overflow: visible !important;
        }
        .widget-type-desc {
          font-size: 14px;
          color: #1e1f24;
        }
        .widget-type-txt {
          font-size: 18px;
          font-weight: 600;
          color: #1e1f24;
        }
         .code-div{
                    width: 500px;
                    height: auto;
                    background: #F0F2F5;
                    border: 1px solid #CDD4DB;
                    border-radius: 2px;
                    padding: 20px;
          }
          .code-div-para{
              line-break:anywhere;
          }
      `}</style>
    </>
  );
};

export default WidgetList;
